export default "__VITE_ASSET__CQsjqey2__"